import { render, staticRenderFns } from "./DeliveryFeesAreasForm.vue?vue&type=template&id=a3cf63d8&scoped=true"
import script from "./DeliveryFeesAreasForm.vue?vue&type=script&lang=ts"
export * from "./DeliveryFeesAreasForm.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryFeesAreasForm.vue?vue&type=style&index=0&id=a3cf63d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3cf63d8",
  null
  
)

export default component.exports